export default __webpack_public_path__ + "static/media/__announcement__icon.9cd87c64.svg";